/* eslint-disable */
// @ts-nocheck

// Scripts used for fitvids modules.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
import { FITVIDS_CUSTOM_SELECTOR } from './constants';

(function ($) {
  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_fitvids_functions = function () {
      const isBuilder = 'object' === typeof window.ET_Builder;
      const et_has_slider = $('.et_pb_slide').length > 0;
      const et_has_fullscreen_section = $('.et_pb_fullscreen').length > 0;

      // Document Ready
      $(() => {
        function fitvids_slider_fullscreen_init() {
          if ($.fn.fitVids) {
            // Default custom and ignore selectors for all modules.
            let customSelector = FITVIDS_CUSTOM_SELECTOR;
            let ignore = '';

            // Library lazysizes convert the iframe video src into data:image,
            // so we need to add src data:image on the list. And also, need to
            // ignore if current iframe has .lazyloading class because it's not
            // visible until it's lazy loaded.
            if (typeof window.lazySizes !== 'undefined') {
              customSelector += ", iframe[src^='data:image']";
              ignore += '.lazyloading';
            }

            $('.et_pb_slide_video').fitVids();
            $('.et_pb_module').fitVids({
              customSelector,
              ignore,
            });
          }

          if (et_has_slider) {
            window.et_fix_slider_height();
          }

          // calculate fullscreen section sizes on $( window ).ready to avoid jumping in some cases
          if (et_has_fullscreen_section) {
            window.et_calculate_fullscreen_section_size();
          }
        }
        if (isBuilder) {
          $(window).one('et_fb_init_app_after', fitvids_slider_fullscreen_init);
        } else {
          fitvids_slider_fullscreen_init();
        }
      });
    };

    window.et_pb_init_fitvids_functions();
  });
})(jQuery);
